/** @jsxImportSource @emotion/react */

import { Button } from "antd";
import Logo from "assets/common/logo.png";
import PaymentMethodImg from "assets/desktop/images/footer/payment-methods.png";
import { useEffect, useState } from "react";

import { ShBlockStyle } from "./index.style";

const describe = `là một nhà cái có giấy phép cá cược trực tuyến hợp pháp do Isle of Man và Khu kinh tế
 Cagayan and Freeport cấp. Với bề dày kinh nghiệm và danh tiếng phục vụ hơn 10 triệu người chơi ,
 ACV88 đã và đang khẳng định vị thế của mình trên thị trường game trực tuyến .
 Với tư cách là một công ty trò chơi trực tuyến trực thuộc Tổng bộ Liên minh OKVIP có trụ sở tại Luân Đôn, Anh, sở hữu đội ngũ nhân
 tài chuyên nghiệp đông đảo cung cấp sản phẩm phục vụ chất lượng cao. ACV88 đảm bảo không tiết lộ thông tin cá nhân khách hàng cho bất kỳ bên thứ ba nào ,
 sử dụng tiêu chuẩn mã hoá dữ liệu ở mức cao nhất. Tất cả thông tin cá nhân đều được thông qua hệ thống bảo mật - Secure Socket (Chuẩn mã hóa SS 128-bit),
 đồng thời được bảo vệ trong môi trường quản lý an toàn đảm bảo không thể truy cập từ các khu vực mạng công cộng. Tất cả dữ liệu ra vào đều bị hạn chế,
  giám sát nghiêm ngặt và quản lý chặt chẽ nhằm mang đến cho người chơi trải nghiệm người dùng an toàn tuyệt đối. `;

const ShBlock = () => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const [textMore, setTextMore] = useState<string>(describe);

  useEffect(() => {
    if (!showMore) {
      setTextMore(describe.slice(0, 181));
      return;
    }
    setTextMore(describe);
  }, [showMore]);

  return (
    <div css={ShBlockStyle.self}>
      <div css={ShBlockStyle.shBox}>
        <img css={ShBlockStyle.logo} src={Logo} alt="" />
        <p css={ShBlockStyle.description}>
          <span>ACV88</span> {textMore}{" "}
          <Button
            type="text"
            css={ShBlockStyle.btnShowMoreDesc}
            onClick={() => setShowMore((prev) => !prev)}
          >
            {showMore ? "Ẩn Bớt" : " ... Xem Thêm"}
          </Button>
        </p>
      </div>
      <div css={ShBlockStyle.paymentBoxWrapper}>
        <div></div>
        <div css={ShBlockStyle.paymentBox}>
          <h4>Phương thức thanh toán</h4>
          <img
            css={ShBlockStyle.paymentMethodImg}
            src={PaymentMethodImg}
            alt="payments-img"
          />
        </div>
      </div>
    </div>
  );
};

export default ShBlock;
